import { Box, Stack } from "@mui/material";
import ProfilePic from "./profilePic";
import ProfileDetails from "./profileDetails";
import ProfileLogout from "./profileLogout";
import ProfileVersion from "./profileVersion";
import { useGetProfileDetailsMutation } from "../../services/profileApi";
import { useEffect, useCallback } from "react";
import { GetAuth } from "../../context/auth/authProvider";
import ErrorView from "../error/errorView";

const ProfileMobileView = () => {
    const auth = GetAuth();
    
    const [
        getProfileData, 
        {
            isLoading: isLoadingGetProfileData,
            isSuccess: isSuccessGetProfileData,
            data: profileData,
            isError: isErrorGetProfileData,
            error: errorGetProfileData
        }
    ] = useGetProfileDetailsMutation();
    
    useEffect(() => {
        if(isSuccessGetProfileData && profileData){
            console.log(profileData);
        }
    }, [isSuccessGetProfileData, profileData]);
    
    useEffect(() => {
        if(auth?.currentUser){
            getProfileData();
        }
    }, [auth]);

    const loadLatestProfileDetails = useCallback(() => {
        getProfileData();
    }, [auth]);

    return (
        <>
            <Stack
                direction='column'
                justifyContent='start'
                alignContent='center'
                width='100%'
                py={isErrorGetProfileData ? 0 : 10}
                display={{xs: 'block', lg: 'none'}}
            >
                {/* Ellipse */}
                <Box
                    sx={{
                        mt: {xs: -10, sm: -20}
                    }}
                >
                    <img 
                        src="/images/Ellipse.png" 
                        alt="Ellipse" 
                        width='100%'
                    />
                </Box>

                <Box sx={{px: 2.5, pt: 0}}>
                    {
                        isErrorGetProfileData
                        ?
                        <Stack pb={10}>
                            <ErrorView 
                                errorTitle="Oops!"
                                errorDescription={errorGetProfileData?.data?.message ?? "Something went wrong"}
                                icon="/images/error.png"
                                height="50vh"
                            />

                            <ProfileLogout />
                        </Stack>
                        :
                        <Stack
                            direction='column'
                            justifyContent='start'
                            alignContent='center'
                            width='100%'
                            spacing={2}
                            pb={2}
                        >
                            <Stack
                                px={10}
                                pb={2}
                            >
                                <ProfilePic 
                                    data={profileData}
                                    isLoading={isLoadingGetProfileData}
                                    loadLatestProfileDetails={loadLatestProfileDetails}
                                />
                            </Stack>

                            <ProfileDetails 
                                data={profileData}
                                isLoading={isLoadingGetProfileData}
                                loadLatestProfileDetails={loadLatestProfileDetails}
                            />

                            <ProfileLogout />
                        </Stack>
                    }

                    <ProfileVersion />
                </Box>
            </Stack>
        </>
    );
}

export default ProfileMobileView;